import axios from "axios";
import React, { Fragment, Dispatch, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { updateCurrentPath } from "../../../store/actions/root.actions";
import SweetAlert from "react-bootstrap-sweetalert";
import { Translate } from "../../../utils/Translate";
import { useIdentity } from "../../../identity/IdentityProvider";
const AdminHome: React.FC = () => {
  let t = new Translate();
  const identity = useIdentity();
  const dispatch: Dispatch<any> = useDispatch();
  // dispatch(updateCurrentPath('home', ''));

  const [msg, setMsg] = useState<any>();

  /**
   * Download a report.
   *
   * The report used to be written to a CSV inside the backend directory, and
   * this then sent the browser to that URL - a plain navigation, which cannot
   * carry the jwt header, so the file had to be readable by anyone to work at
   * all. It now comes back in the authenticated response itself and is saved
   * from memory, so the roster never exists as a public file.
   */
  const reportHandler = async (type: string) => {
    const endpoint =
      type === "Assigned" ? "assignedTripsReport.php" : "requestedTripsReport.php";

    try {
      const res = await axios.get(endpoint, { responseType: "blob" });

      // A failure still arrives as a blob; the backend answers JSON for those.
      const contentType = String(res.headers["content-type"] || "");
      if (contentType.indexOf("text/csv") === -1) {
        setMsg(
          <SweetAlert
            danger
            title={t.translate("Could not generate the report")}
            onConfirm={() => setMsg("")}
          ></SweetAlert>
        );
        return;
      }

      // The school's own name is on the filename, set by the backend from the
      // same tenant row the page is branded from.
      let filename = `${type} trips report.csv`;
      const disposition = String(res.headers["content-disposition"] || "");
      const match = disposition.match(/filename="?([^"]+)"?/);
      if (match) filename = match[1];

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      setMsg(
        <SweetAlert success title={t.translate("Report downloaded")} onConfirm={() => setMsg("")}></SweetAlert>
      );
    } catch (e) {
      setMsg(
        <SweetAlert
          danger
          title={t.translate("Could not generate the report")}
          onConfirm={() => setMsg("")}
        ></SweetAlert>
      );
    }
  };
  return (
    <Fragment>
      {msg}
      <div className="text-center">
        <h2
          className="text-white"
          style={{
            textShadow:
              "0px 4px 3px rgba(0,0,0,0.4), 0px 8px 13px rgba(0,0,0,0.1), 0px 18px 23px rgba(0,0,0,0.1)",
            fontSize: "2rem",
          }}
        >
          {identity.shortName
            ? `${identity.shortName} ${t.translate("Transportation Administration")}`
            : t.translate("Transportation Administration")}
        </h2>

        <div className="row mt-5">
          <div className="col-6">
            <button
              onClick={() => {
                reportHandler("Assigned");
              }}
              className="btn btn-success my-1 text-white font-weight-bold"
            >
              {t.translate("Assigend trips report")}
            </button>
          </div>
          <div className="col-6">
            <button
              onClick={() => {
                reportHandler("Requested");
              }}
              className="btn btn-success my-1 text-white font-weight-bold"
            >
              {t.translate("Requested trips report")}
            </button>
          </div>
        </div>
      </div>
      <div className="row justify-content-center align-content-between"></div>
    </Fragment>
  );
};

export default AdminHome;
